import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import {
  Col,
  Container,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Button,
  Toast,
  ToastBody,
  ToastHeader,
  Input
} from "reactstrap";
import NewHeadsetModal from "../Modals/NewHeadsetModal.js";
import SelectContentsModal from "../Modals/SelectContentsModal.js";
import EditHeadsetModal from "../Modals/EditHeadsetModal.js";
import { s } from "framer-motion/client";


const ParcXr = () => {
  const [headsets, setHeadsets] = useState([]);
  const [users, setUsers] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  const [showContentsModal, setShowContentsModal] = useState(false);
  const [selectedHeadsetId, setSelectedHeadsetId] = useState(null);

  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedHeadset, setSelectedHeadset] = useState(null);

  const [showSuccessToast, setShowSuccessToast] = useState(false);
  const [showErrorToast, setShowErrorToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");

  const showSuccess = (message) => {
    setShowErrorToast(false);
    setToastMessage(message);
    setShowSuccessToast(true);
    setTimeout(() => setShowSuccessToast(false), 3000);
  };

  const showError = (message) => {
    setShowSuccessToast(false);
    setToastMessage(message);
    setShowErrorToast(true);
    setTimeout(() => setShowErrorToast(false), 3000);
  };


  const fetchUsers = async () => {
    try {
      const res = await axios.get("/api/user/list", { withCredentials: true });
      setUsers(Array.isArray(res) ? res : []);
    } catch (err) {
      console.error(err);
    }
  };

  const fetchHeadsets = async () => {
    try {
      const res = await axios.get("/api/headset/list-headsets", { withCredentials: true });

      console.log("TYPE RES:", typeof res);
      console.log("RES:", res);
      console.log("RES.DATA:", res.data);

      setHeadsets(res); // mets ça temporairement
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchUsers();
    fetchHeadsets();
  }, []);

  useEffect(() => {
    const handleRefresh = () => {
      console.log("🔥 REFRESH EVENT REÇU");
      fetchHeadsets();
    };

    window.addEventListener("refreshHeadsets", handleRefresh);
    console.log("👂 Listener attaché");

    return () => {
      window.removeEventListener("refreshHeadsets", handleRefresh);
      console.log("🧹 Listener retiré");
    };
  }, []);

  // Assigner un utilisateur à un casque
  const handleAssignUser = async (headset_id, user_ID) => {
    try {
      await axios.post("/api/headset/assign-user", { headset_id, user_ID }, { withCredentials: true });
      fetchHeadsets();
      showSuccess("Utilisateur assigné avec succès !");
    } catch (err) {
      console.error(err.response?.data || err);
      showError(err.response?.data?.message || "Erreur lors de l'assignation de l'utilisateur");
    }
  };

  // Désassigner l'utilisateur d'un casque
  const handleUnassignUser = async (headset_id) => {
    try {
      await axios.post("/api/headset/unassign-user", { headset_id }, { withCredentials: true });
      fetchHeadsets();
      showSuccess("Utilisateur détaché avec succès !");
    } catch (err) {
      console.error(err.response?.data || err);
      showError(err.response?.data?.message || "Erreur lors du détachement de l'utilisateur");
    }
  };

  // Supprimer un casque
  const handleHeadsetDeleted = async (headset_id) => {
    if (!window.confirm("Voulez-vous vraiment supprimer ce casque ?")) return;

    try {
      await axios.delete(`/api/headset/delete/${headset_id}`, {
        withCredentials: true
      });
      fetchHeadsets();
      showSuccess("Casque supprimé avec succès !");
    } catch (err) {
      console.error(err.response?.data || err);
      showError(err.response?.data?.message || "Erreur lors de la suppression du casque");
    }
  };

  // Récupérer l'email d'un utilisateur par son ID
  const getUserEmailById = (userId) => {
    const user = users.find(u => u.user_ID === userId);
    return user ? user.user_EMAIL : null;
  };

  // Récupérer le prénom et le nom d'un utilisateur par son ID (pour l'affichage)
  const getUserFullNameById = (userId) => {
    const user = users.find(u => u.user_ID === userId);
    if (!user) return null;
    const fullName = `${user.user_NAME || ""} ${user.user_SURNAME || ""}`.trim();
    return fullName || user.user_EMAIL || null;
  };

  // Après création d'un casque, rafraîchir la liste
  const handleHeadsetCreated = () => {
    fetchHeadsets();
    showSuccess("Casque créé avec succès !");
  };

  // Ouvrir le modal de sélection de contenus
  const [selectedHeadsetContents, setSelectedContents] = useState("");
  const openContentsModal = (headset) => {
    setSelectedHeadsetId(headset.headset_id);
    setSelectedContents(headset.headset_CONTENTS || "");
    setShowContentsModal(true);
  };

  // Retirer un contenu assigné d'un casque
  const handleRemoveContent = async (headsetId, contentToRemove) => {
    try {
      const headset = headsets.find(h => h.headset_id === headsetId);
      if (!headset || !headset.headset_CONTENTS) return;

      const newContents = headset.headset_CONTENTS
        .split("|")
        .filter(c => c !== contentToRemove);

      await axios.post(
        "/api/headset/assign-contents",
        { headset_id: headsetId, contents: newContents },
        { withCredentials: true }
      );

      fetchHeadsets();
      showSuccess("Contenu retiré avec succès !");
    } catch (err) {
      console.error(err.response?.data || err);
      showError(err.response?.data?.message || "Erreur lors du retrait du contenu");
    }
  };

  // Confirmer avant de retirer un contenu
  const handleConfirmRemoveContent = (headsetId, contentToRemove) => {
    if (window.confirm("Voulez-vous vraiment supprimer ce contenu ?")) {
      handleRemoveContent(headsetId, contentToRemove);
      showSuccess("Contenu retiré avec succès !");
    }
  };

  const openEditModal = (headset) => {
    setSelectedHeadset(headset);
    setShowEditModal(true);
  };

  const displayedHeadsets = useMemo(() => {
    const search = searchTerm.trim().toLowerCase();
    if (!search) return headsets;

    return headsets.filter(headset => {
      const userEmail = getUserEmailById(headset.headset_USER_ID) || "";
      const haystack = `${headset.headset_NAME || ""} ${headset.headset_MODEL || ""} ${headset.headset_PID || ""} ${userEmail}`.toLowerCase();
      return haystack.includes(search);
    });
  }, [headsets, users, searchTerm]);


  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Col lg={12}>
            <div className="card">
              <div className="card-body">
                <h1 className="text-primary text-center">Parc XR</h1>
                <h2 className="text-tertiary mb-4 text-center">
                  Gestion des masques et assignations
                </h2>

                <div className="mb-3 d-flex justify-content-center">
                  <div className="position-relative" style={{ maxWidth: "400px", width: "100%" }}>
                    <Input
                      type="text"
                      placeholder="Rechercher ..."
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      style={{ paddingRight: "30px" }}
                    />
                    {searchTerm && (
                      <button
                        type="button"
                        title="Effacer la recherche"
                        onClick={() => setSearchTerm("")}
                        className="bg-transparent border-0 p-0 text-muted"
                        style={{
                          position: "absolute",
                          right: "10px",
                          top: "50%",
                          transform: "translateY(-50%)",
                          lineHeight: 1
                        }}
                      >
                        <i className="mdi mdi-close-circle"></i>
                      </button>
                    )}
                  </div>
                </div>

                <div className="table-responsive" /* style={{ overflow: "visible" }} */>
                  <table className="table table-centered mb-0" style={{ tableLayout: 'fixed', width: '100%' }}>
                    <thead>
                      <tr>
                        <th className="text-break" style={{ width: "160px" }}>Nom</th>
                        <th className="text-break" style={{ width: '120px' }}>Modele</th>
                        <th className="text-break" style={{ width: "110px" }}>PID</th>
                        <th className="text-break" style={{ width: "250px" }}>Utilisateur</th>
                        <th className="text-break" style={{ width: "300px" }}>Contenus</th>
                        <th style={{ width: "150px" }}>Actions</th>
                      </tr>
                    </thead>

                    <tbody>
                      {displayedHeadsets.length > 0 ? (
                        displayedHeadsets.map(headset => (
                          <tr key={headset.headset_id}>
                            <td className="text-break" >
                              {headset.headset_NAME || "—"}
                            </td>
                            <td className="text-break" >
                              {headset.headset_MODEL || "—"}
                            </td>
                            <td className="text-break small" >
                              {headset.headset_PID || "—"}
                            </td>

                            {/* UTILISATEUR */}
                            <td className="text-break" >
                              {headset.headset_USER_ID ? (
                                <>
                                  <Button
                                    title="Détacher cet utilisateur"
                                    color="outline-warning"
                                    size="sm"
                                    className="fs-4 py-0 px-1 mx-2"
                                    onClick={() => handleUnassignUser(headset.headset_id)}
                                  >
                                    <i className="mdi mdi-account-minus"></i>
                                  </Button>
                                  {getUserFullNameById(headset.headset_USER_ID) || "Utilisateur inconnu"}
                                </>
                              ) : (
                                <UncontrolledDropdown>
                                  <DropdownToggle color="outline-primary" size="sm" caret className="mx-2 py-0 px-1">
                                    <i className="mdi mdi-account-plus fs-4 align-middle"></i> Assigner un utilisateur
                                  </DropdownToggle>
                                  <DropdownMenu
                                    style={{ maxHeight: "200px", overflowY: "auto" }}
                                    flip
                                  >
                                    {users.length > 0 ? (
                                      users.map(user => (
                                        <DropdownItem
                                          key={user.user_ID}
                                          onClick={() => handleAssignUser(headset.headset_id, user.user_ID)}
                                        >
                                          <i className="mdi mdi-account fs-4 align-middle me-2"></i>
                                          {getUserFullNameById(user.user_ID) || user.user_EMAIL}
                                        </DropdownItem>
                                      ))
                                    ) : (
                                      <DropdownItem disabled>
                                        Aucun utilisateur
                                      </DropdownItem>
                                    )}
                                  </DropdownMenu>
                                </UncontrolledDropdown>
                              )}
                            </td>

                            {/* CONTENUS */}
                            <td>
                              {headset.headset_CONTENTS ? (
                                headset.headset_CONTENTS.split("|").map((content, index) => {
                                  const parts = content.split("/");
                                  const user = parts[0] || "";
                                  const project = parts[1] || "";
                                  const lang = parts[2] || "";

                                  return (
                                    <div key={index} className="mb-1 d-flex align-items-center flex-wrap" style={{ wordBreak: 'break-all' }}>
                                      <Button
                                        title="Supprimer ce contenu"
                                        color="outline-warning"
                                        size="sm"
                                        className="fs-7 py-0 px-1 me-2"
                                        onClick={() => handleConfirmRemoveContent(headset.headset_id, content)}
                                      >

                                        <i className="mdi mdi-folder-remove-outline fs-5"></i>
                                      </Button>
                                      {/*     <span className="badge bg-gray500 me-1">{user.split("@")[0]}</span>
                                      <span className="badge bg-gray550 me-1">{project}</span>
                                      <span className="badge bg-gray600 me-1">{lang}</span> */}
                                      <span className="badge bg-dark me-1">{user.split("@")[0]}</span>
                                      <span className="badge bg-secondary me-1">{project}</span>
                                      <span className="badge bg-info me-1">{lang}</span>
                                      <br />
                                    </div>
                                  );
                                })
                              ) : (
                                <>
                                  <Button
                                    title="Assigner du contenu"
                                    color="outline-secondary"
                                    size="sm"
                                    className="py-0"
                                    onClick={() => openContentsModal(headset)}
                                  >
                                    <i className="mdi mdi-folder-information-outline fs-4 align-middle"></i>  Aucun contenu assigné
                                  </Button>
                                </>
                              )}
                            </td>

                            {/* ACTIONS */}
                            <td>
                              <Button
                                title={`Gérer les contenus du ${headset.headset_NAME || "—"}`}
                                color="outline-success"
                                size="sm"
                                className="fs-4 py-0 px-1 mx-1"
                                onClick={() => openContentsModal(headset)}
                              >
                                <i className="mdi mdi-folder-plus-outline"></i>
                              </Button>
                              <Button
                                title={`Éditer les informations du ${headset.headset_NAME || "—"}`}
                                color="outline-primary"
                                size="sm"
                                className="fs-4 py-0 px-1 mx-1"
                                onClick={() => openEditModal(headset)}
                              >
                                <i className="bx bxs-mask align-middle"></i>
                              </Button>


                              <Button
                                title={`Supprimer ${headset.headset_NAME || "—"} du parc XR`}
                                onClick={() => handleHeadsetDeleted(headset.headset_id)}
                                color="outline-danger"
                                size="sm"
                                className="fs-4 py-0 px-1 mx-1"
                              >
                                <i className="mdi mdi-trash-can-outline align-middle"></i>
                              </Button>

                            </td>

                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="4" className="text-center text-muted">
                            Aucun casque XR
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>

                <div className="mb-3 mt-4 d-flex justify-content-center">
                  <NewHeadsetModal onHeadsetCreated={handleHeadsetCreated} />
                </div>
              </div>
            </div>
          </Col>
        </Container>
      </div>
      <SelectContentsModal
        isOpen={showContentsModal}
        toggle={() => setShowContentsModal(false)}
        headsetId={selectedHeadsetId}
        initialContents={selectedHeadsetContents}
        onSaved={() => {
          fetchHeadsets();
          showSuccess("Contenu assigné avec succès");
        }}
      />

      <EditHeadsetModal
        isOpen={showEditModal}
        toggle={() => setShowEditModal(false)}
        headset={selectedHeadset}
        onSaved={() => {
          fetchHeadsets();
          showSuccess("Casque modifié avec succès");
        }}
      />

      {/* Toast de succès */}
      <div
        style={{
          position: 'fixed',
          top: '20px',
          right: '20px',
          zIndex: 9999,
        }}
      >
        <Toast isOpen={showSuccessToast}>
          <ToastHeader
            icon="success"
            toggle={() => setShowSuccessToast(false)}
            style={{ backgroundColor: '#d4edda', color: '#155724' }}
          >
            Succès
          </ToastHeader>
          <ToastBody style={{ backgroundColor: '#d4edda', color: '#155724' }}>
            {toastMessage}
          </ToastBody>
        </Toast>
      </div>

      {/* Toast d'erreur */}
      <div
        style={{
          position: 'fixed',
          top: '20px',
          right: '20px',
          zIndex: 9999,
        }}
      >
        <Toast isOpen={showErrorToast}>
          <ToastHeader
            icon="danger"
            toggle={() => setShowErrorToast(false)}
            style={{ backgroundColor: '#f8d7da', color: '#721c24' }}
          >
            Erreur
          </ToastHeader>
          <ToastBody style={{ backgroundColor: '#f8d7da', color: '#721c24' }}>
            {toastMessage}
          </ToastBody>
        </Toast>
      </div>
    </React.Fragment>
  );
};

export default ParcXr;


//Creators : Florian Cohen-Joly @3DDGAMES -- Under license